import { render } from "./Member.vue?vue&type=template&id=42eaad48"
const script = {}
script.render = render

export default script